import * as Sentry from "@sentry/react";
import { TypeWireContainer } from "@typewirets/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// start of style imports
import App from "./App.tsx";
import { MainWires } from "./main.wires.ts";
import "./index.css";
// end of style imports

async function main() {
  // Parse API URL for trace propagation
  const apiUrl = new URL(
    import.meta.env.VITE_API_URL || "http://localhost:8000",
  );

  const environment = import.meta.env.VITE_ENV || "dev";

  if (environment !== "dev") {
    Sentry.init({
      dsn: "https://63a67126211ef53d0e1073931c7e3e6b@o4508780440715264.ingest.us.sentry.io/4508780551143424",
      environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          mask: [
            'input[type="password"]',
            'input[type="email"]',
            'input[type="tel"]',
          ],
        }),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [apiUrl.host],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  const container = new TypeWireContainer();
  await MainWires.apply(container);
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App container={container} />
    </StrictMode>,
  );
}

main();
